import { createReducer, on } from '@ngrx/store';
import * as fromDatabaseActions from '../actions/database.action';

export const featureKey = 'database';

export interface State {
    databaseList: {
        data: Array<any>,
        isLoaded: boolean
    };
    databaseDetails: {
        data: any,
        isLoaded: boolean
    };
}

export const initialState: State = {
    databaseList: {
        data: [],
        isLoaded: false
    },
    databaseDetails: {
        data: null,
        isLoaded: false
    }
};

export const reducer = createReducer(
    initialState,
    
    on(fromDatabaseActions.getDatabaseListSuccess, (state: State, props: any) => ({
        ...state,
        databaseList: { data: props.data, isLoaded: true },
    })),
    
    on(fromDatabaseActions.getDatabaseDetailsSuccess, (state: State, props: any) => ({
        ...state,
        databaseDetails: { data: props.data, isLoaded: true },
    })),
);